<template>
  <div class="item-component">
    <div class="s-item-title">
      <h4 class="chart-title">
        <i class="el-icon-s-grid"></i>
        各院系新生专业调整情况
      </h4>
    </div>
    <chart-seven style="height: 90%" :value="chartData"></chart-seven>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ChartSeven from "../charts/chart07";
// import { chartData07 } from "@/assets/json/chartData";
export default {
  components: {
    ChartSeven,
  },
  data() {
    return {
      chartData: [],
      enrollmentYear: "",
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_CURRENTYEAR"]),
  },
  created() {
    this.enrollmentYear = this._CURRENTYEAR[0].value;
    this.getCollegeExchangeMajorNum();
  },
  mounted() {},
  methods: {
    // 获取各院系新生专业调整情况
    getCollegeExchangeMajorNum() {
      this.$http
        .get("/welcome-forecast/statistics/getCollegeExchangeMajorNum")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            console.log(res);
            this.chartData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>

<style>
</style>